/** Documentação do módulo
 * :idConfigClienteApp será substituído pelo valor recebido pelo $router.params.idConfigClienteApp
 {
 'name': 'Nome do módulo',
 'icon': 'support_agent',
 'iconFill': true,
 'routerName': 'GestorAtendimento', // Nome da rota utilizado para pegar a configuração
 'routerPath': '/plataforma/:idConfigClienteApp/GestorAtendimento', // Rota do painel omnichannel
 'embedPath': 'configurador-aplicacao/:idConfigClienteApp', // path que vai ser passado no json de configuração do embed
 'embedUrl': process.env.VUE_APP_URL_OMNI_GESTOR_ATENDIMENTO_FRONT, // Valor opcional, URL do embed. Valor padrão VUE_APP_URL_CONFIGURADOR_PUBLICO_FRONT
 'tipoAplicacao': [1], // array com o tipo_aplicacao que tem acesso a esse modúlo. Caso vazio, será exibido como módulo global
 'externalLink': false, // Abrir como URL externa
 'externalLinkNewTab': false, // Abrir URL externa como uma nova aba
 'idMenu': 206,
 'showNavCardDash': true, // exibe o card do módulo
 'description': 'Descrição que vai aparecer no card do módulo.' // Descrição exibida no card do módulo
 },
 */
export default [
  {
    'name': 'Início',
    'title': 'Mosia OmniChannel',
    'routerName': 'Home',
    'routerPath': '/plataforma/:idConfigClienteApp',
    'idMenu': 9,
    'icon': 'home',
    'iconFill': true,
    'externalLink': false,
    'showChilds': false,
    'showNavCardDash': false,
    'childs': []
  },
  {
    'name': 'Funcionalidades',
    'title': 'Funcionalidades',
    'routerName': 'Funcionalidades',
    'routerPath': '/plataforma/:idConfigClienteApp',
    'idMenu': 3,
    'icon': 'widgets',
    'iconFill': true,
    'externalLink': false,
    'showChilds': true,
    'showNavCardDash': true,
    'childs': [
      {
        'name': 'Configurador de Funcionalidades',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'ConfiguradorAplicacao',
        'routerPath': '/plataforma/:idConfigClienteApp/ConfiguradorAplicacao',
        'embedPath': 'configurador-aplicacao/:idConfigClienteApp',
        'tipoAplicacao': [1, 2],
        'externalLink': false,
        'idMenu': 300,
        'showNavCardDash': true,
        'description': 'Gerencie seu app e site fazendo testes em sandbox ou promovendo novas versões para produção. Edite funcionalidades, cores e muito mais.'
      },
      {
        'name': 'Funcionalidades Customizadas',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'ConfiguradorFuncionalidadesCustomizadas',
        'routerPath': '/plataforma/:idConfigClienteApp/ConfiguradorFuncionalidadesCustomizadas',
        'embedPath': 'configurador-aplicacao/:idConfigClienteApp/funcionalidades-customizadas',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 301,
        'showNavCardDash': true,
        'description': 'Crie novas funcionalidades por meio de webviews.'
      }
    ]
  },
  {
    'name': 'Conteúdos',
    'title': 'Conteúdos',
    'routerName': 'Conteudos',
    'routerPath': '/plataforma/:idConfigClienteApp',
    'idMenu': 6,
    'icon': 'newspaper',
    'iconFill': true,
    'externalLink': false,
    'showChilds': true,
    'showNavCardDash': true,
    'childs': [
      {
        'name': 'Notícias',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'ListaNoticias',
        'routerPath': '/plataforma/:idConfigClienteApp/ListaNoticias',
        'embedPath': '/cms/indicadores/noticias/:idConfigClienteApp',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 600,
        'showNavCardDash': true,
        'description': 'Gerencie notícias para o app e site. É possível programar uma data de exibição e controlar a publicação entre plataformas.',
        'actions': [{
          'label': 'Gerenciar notícias',
          'externalLink': true,
          'routerName': 'ListaNoticias'
        }]
      },
      {
        'name': 'Banners',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'ListaBanners',
        'routerPath': '/plataforma/:idConfigClienteApp/ListaBanners',
        'embedPath': 'cms/indicadores/banners/:idConfigClienteApp',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 601,
        'showNavCardDash': true,
        'description': 'Gerencie banners para o app e site. É possível programar uma data de exibição e controlar a publicação entre plataformas.',
        'actions': [{
          'label': 'Gerenciar banners',
          'externalLink': true,
          'routerName': 'ListaBanners'
        }]
      },
      {
        'name': 'Revistas e manuais',
        'icon': 'code',
        'iconFill': true,
        'routerName': 'ListaRevistas',
        'routerPath': '/plataforma/:idConfigClienteApp/ListaRevistas',
        'embedPath': 'cms/indicadores/revistas/:idConfigClienteApp',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 602,
        'showNavCardDash': true,
        'description': 'Gerencie arquivos para download no app e site. É possível criar diferentes categorias de arquivos.',
        'actions': [{
          'label': 'Gerenciar revistas e manuais',
          'externalLink': true,
          'routerName': 'ListaRevistas'
        }]
      },
      {
        'name': 'Filtros de Segmentação',
        'icon': 'cloud',
        'iconFill': true,
        'routerName': 'ListaFiltrosSegmentacao',
        'routerPath': '/plataforma/:idConfigClienteApp/ListaFiltrosSegmentacao',
        'embedPath': 'conteudo/:idConfigClienteApp/filtros-segmentacao',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 604,
        'showNavCardDash': true,
        'description': 'Gerencie os filtros de segmentação de sua operadora. Os filtros podem ser usados na seleção e envios de conteúdos.'
      },
      {
        'name': 'Guia impresso',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'GuiaImpresso',
        'routerPath': '/plataforma/:idConfigClienteApp/GuiaImpresso',
        'embedPath': 'conteudo/:idConfigClienteApp/guia-impresso',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 605,
        'showNavCardDash': true,
        'description': 'Gerencie os guias impresso.'
      },
      {
        'name': 'Contatos',
        'icon': 'cloud',
        'iconFill': true,
        'routerName': 'ListaContatos',
        'routerPath': '/plataforma/:idConfigClienteApp/ListaContatos',
        'tipoAplicacao': [1],
        'externalLink': true,
        'externalLinkNewTab': true,
        'idMenu': 603,
        'showNavCardDash': true,
        'description': 'Gerencie os contatos de sua operadora: telefone, e-mail, endereços, etc. Podem ser agrupados em diferentes categorias.'
      },
      {
        'name': 'Páginas',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'ListaPaginas',
        'routerPath': '/plataforma/:idConfigClienteApp/ListaPaginas',
        'tipoAplicacao': [1],
        'externalLink': true,
        'externalLinkNewTab': true,
        'idMenu': 605,
        'showNavCardDash': true,
        'description': 'Gerencie as páginas.'
      },
      {
        'name': 'Publicações',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'ListaPublicacoes',
        'routerPath': '/plataforma/:idConfigClienteApp/ListaPublicacoes',
        'tipoAplicacao': [1],
        'externalLink': true,
        'externalLinkNewTab': true,
        'idMenu': 605,
        'showNavCardDash': true,
        'description': 'Gerencie as publicações.'
      },
      {
        'name': 'Eventos ou assembleias',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'ListaEventos',
        'routerPath': '/plataforma/:idConfigClienteApp/ListaEventos',
        'tipoAplicacao': [1],
        'externalLink': true,
        'externalLinkNewTab': true,
        'idMenu': 605,
        'showNavCardDash': true,
        'description': 'Gerencie os eventos e assembleias.'
      },
      {
        'name': 'Permalink',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'ListaPermalink',
        'routerPath': '/plataforma/:idConfigClienteApp/ListaPermalink',
        'tipoAplicacao': [1],
        'externalLink': true,
        'externalLinkNewTab': true,
        'idMenu': 605,
        'showNavCardDash': true,
        'description': 'Crie uma página para compartilhar notícias.'
      }
    ]
  },
  {
    'name': 'Ferramentas',
    'title': 'Ferramentas',
    'routerName': 'Ferramentas',
    'routerPath': '/plataforma/:idConfigClienteApp',
    'idMenu': 5,
    'icon': 'build',
    'iconFill': true,
    'externalLink': false,
    'showChilds': true,
    'showNavCardDash': true,
    'childs': [
      {
        'name': 'Construtor de Formulários',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'FormBuilder',
        'routerPath': '/plataforma/:idConfigClienteApp/FormBuilder',
        'tipoAplicacao': [1],
        'externalLink': true,
        'externalLinkNewTab': true,
        'idMenu': 500,
        'showNavCardDash': true,
        'description': 'Também con hecido como Form Builder, permite a edição e criação de formulários para o site e app. Uma poderosa ferramenta de customização.'
      },
      {
        'name': 'Lotes de importação',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'ListaImportador',
        'routerPath': '/plataforma/:idConfigClienteApp/ListaImportador',
        'embedPath': 'configurador-aplicacao/:idConfigClienteApp/importador-list',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 501,
        'showNavCardDash': true,
        'description': 'NOVO importador mais rápido! Importe os dados de seus beneficiários e sua rede credenciada.'
      },
      {
        'name': 'Construtor de Cartão Unimed',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'ConfiguradorCartaoUnimed',
        'routerPath': '/plataforma/:idConfigClienteApp/ConfiguradorCartaoUnimed',
        'embedPath': 'configurador-aplicacao/:idConfigClienteApp/unimed-cartao',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 502,
        'showNavCardDash': true,
        'description': 'Crie e edite cartões virtuais seguindo os padrões do PTU. Exclusivo para clientes Unimed.'
      },
      {
        'name': 'Construtor de Cartão Virtual',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'ConfiguradorCartaoVirtual',
        'routerPath': '/plataforma/:idConfigClienteApp/ConfiguradorCartaoVirtual',
        'embedPath': 'configurador-aplicacao/:idConfigClienteApp/cartao',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 503,
        'showNavCardDash': true,
        'description': 'Crie e edite cartões virtuais. É possível criar diferentes modelos de cartões e atribuí-los à diferentes tipos de clientes.'
      },
      {
        'name': 'Cadastro de Hooks',
        'icon': 'cloud',
        'iconFill': true,
        'routerName': 'Hook',
        'routerPath': '/plataforma/:idConfigClienteApp/Hook',
        'embedPath': 'hook',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 504,
        'showNavCardDash': true,
        'description': 'Crie e edite hooks, para enviar informações sobre ocorrências na aplicação para um endpoint específico.'
      },
      {
        'name': 'Central de Hooks',
        'icon': 'cloud',
        'iconFill': true,
        'routerName': 'CentralHook',
        'routerPath': '/plataforma/:idConfigClienteApp/CentralHook',
        'embedPath': 'central-hook',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 505,
        'showNavCardDash': true,
        'description': 'Monitore seus hooks cadastrados, podendo pausar seu funcionamento'
      },
      {
        'name': 'Gestor de dados',
        'icon': 'cloud',
        'iconFill': true,
        'routerName': 'ListaBeneficiario',
        'routerPath': '/plataforma/:idConfigClienteApp/ListaBeneficiario',
        'embedPath': 'configurador-aplicacao/:idConfigClienteApp/beneficiario',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 513,
        'showNavCardDash': true,
        'description': 'Visualize a base de dados de beneficiários importada e ativa nos ambientes de produção e sandbox'
      },
      {
        'name': 'OmniLink',
        'icon': 'link',
        'iconFill': true,
        'routerName': 'OmniLink',
        'routerPath': '/plataforma/:idConfigClienteApp/OmniLink',
        'embedPath': 'omnilink',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 514,
        'showNavCardDash': true,
        'description': 'Gerencie e instale em sua infraestrutura os módulos do Omnilink. Integre sua aplicação através do seu Banco de Dados, utilizando views.'
      },
      {
        'name': 'Configurador de domínio',
        'icon': 'link',
        'iconFill': true,
        'routerName': 'ConfiguradorDominio',
        'routerPath': '/plataforma/:idConfigClienteApp/ConfiguradorDominio',
        'embedPath': 'configurador-dominio',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 515,
        'showNavCardDash': true,
        'description': 'Gerencie os domínios (endereços WEB) que darão acesso ao seu portal do beneficiário.'
      },
      {
        'name': 'Perfis de usuários do APP',
        'icon': 'link',
        'iconFill': true,
        'routerName': 'PerfilUsuarioApp',
        'routerPath': '/plataforma/:idConfigClienteApp/PerfilUsuarioApp',
        'embedPath': 'perfilUsuarioApp/:idConfigClienteApp',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 516,
        'showNavCardDash': true,
        'description': 'Gerencie os perfils de usuários do aplicativo.'
      }
    ]
  },
  {
    'name': 'Ocorrências',
    'title': 'Ocorrências',
    'routerName': 'Ocorrencias',
    'routerPath': '/plataforma/:idConfigClienteApp',
    'idMenu': 2,
    'icon': 'dvr',
    'iconFill': false,
    'externalLink': false,
    'showChilds': true,
    'showNavCardDash': true,
    'childs': [
      {
        'name': 'Tipos de Protocolos',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'ConfiguracaoProtocolos',
        'routerPath': '/plataforma/:idConfigClienteApp/ConfiguracaoProtocolos',
        'embedPath': 'tipo-protocolo',
        'embedUrl': process.env.VUE_APP_URL_OCORRENCIA_FRONT,
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 200,
        'showNavCardDash': true,
        'description': 'Crie e gerencie os tipos de protocolos, podendo fazer uma integração por meio de URLs.'
      },
      {
        'name': 'Tipos de Ocorrência',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'ConfiguracaoOcorrencias',
        'routerPath': '/plataforma/:idConfigClienteApp/ConfiguracaoOcorrencias',
        'embedPath': 'tipo-ocorrencia',
        'embedUrl': process.env.VUE_APP_URL_OCORRENCIA_FRONT,
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 201,
        'showNavCardDash': true,
        'description': 'Uma poderosa ferramenta para gerenciar os tipos de ocorrência, com atribuição de status e prazos SLA'
      },
      {
        'name': 'Assuntos',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'ConfiguradorAssunto',
        'routerPath': '/plataforma/:idConfigClienteApp/ConfiguradorAssunto',
        'embedPath': 'assunto',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 202,
        'showNavCardDash': true,
        'description': 'Gerencie os tipos de assuntos. Estes assuntos poderão ser atribuídos em diferentes tipos de ocorrências.'
      },
      {
        'name': 'Motivos de Encerramento',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'ConfiguradorMotivoEncerramento',
        'routerPath': '/plataforma/:idConfigClienteApp/ConfiguradorMotivoEncerramento',
        'embedPath': 'motivoEncerramento/:idConfigClienteApp',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 204,
        'showNavCardDash': true,
        'description': 'Crie gerencie modelos de encerramentos para diferentes situações de atendimento.'
      },
      {
        'name': 'Canais de Atendimento',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'ConfiguradorCanalAtendimento',
        'routerPath': '/plataforma/:idConfigClienteApp/ConfiguradorCanalAtendimento',
        'embedPath': 'canal-atendimento',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 206,
        'showNavCardDash': true,
        'description': 'Gerencie os tipos de canais de atendimento. Estes canais poderão ser atribuídos em diferentes tipos de ocorrências.'
      },
      {
        'name': 'Template de Atendimento',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'ConfiguradorTemplateAtendimento',
        'routerPath': '/plataforma/:idConfigClienteApp/ConfiguradorTemplateAtendimento',
        'embedPath': 'template-atendimento',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 207,
        'showNavCardDash': true,
        'description': 'Crie e gerencie modelos de atendimento para diferentes situações de atendimento.'
      },
      {
        'name': 'Templates de Solicitação',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'ConfiguradorSolicitacoes',
        'routerPath': '/plataforma/:idConfigClienteApp/ConfiguradorSolicitacoes',
        'embedPath': 'configurador-aplicacao/:idConfigClienteApp/templates-de-solicitacao',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 203,
        'showNavCardDash': true,
        'description': 'Crie e gerencie seus modelos de solicitações. Você pode customizar a vontade e criar links com novas funcionalidades.'
      },
      {
        'name': 'Templates de Pesquisa',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'ConfiguradorTemplatePesquisa',
        'routerPath': '/plataforma/:idConfigClienteApp/ConfiguradorTemplatePesquisa',
        'embedPath': 'templatePesquisa',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 207,
        'showNavCardDash': true,
        'description': 'Crie e gerencie seus templates de pesquisa.'
      },
      {
        'name': 'Calculo de Pesquisa',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'ConfiguradorCalculoPesquisa',
        'routerPath': '/plataforma/:idConfigClienteApp/ConfiguradorCalculoPesquisa',
        'embedPath': 'calculoPesquisa',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 208,
        'showNavCardDash': true,
        'description': 'Crie e gerencie seu calculo de pesquisa.'
      },
      {
        'name': 'Relatórios Ocorrência',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'RelatorioOcorrencia',
        'routerPath': '/plataforma/:idConfigClienteApp/RelatorioOcorrencia',
        'embedPath': 'historico-ocorrencia/:idConfigClienteApp/0',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 209,
        'showNavCardDash': true,
        'description': 'Crie relatórios das ocorrências.'
      },
      {
        'name': 'Relatórios de Ocorrências de Chat',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'RelatorioChat',
        'routerPath': '/plataforma/:idConfigClienteApp/RelatorioChat',
        'embedPath': 'historico-ocorrencia/:idConfigClienteApp/1',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 209,
        'showNavCardDash': true,
        'description': 'Crie relatórios dos chats.'
      }
    ]
  },
  {
    'name': 'Mensageria',
    'title': 'Mensageria',
    'routerName': 'Mensageria',
    'routerPath': '/plataforma/:idConfigClienteApp',
    'idMenu': 7,
    'icon': 'mail_outline',
    'iconFill': true,
    'externalLink': false,
    'showChilds': true,
    'showNavCardDash': true,
    'childs': [
      {
        'name': 'Cadastro de Contas de E-mail',
        'icon': 'email',
        'iconFill': true,
        'routerName': 'ContaEmail',
        'routerPath': '/plataforma/:idConfigClienteApp/ContaEmail',
        'embedPath': 'conta-email',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 700,
        'showNavCardDash': true,
        'description': 'Cadastre e-mails junto à AWS (Amazon) para poder enviar e-mails seguros e autenticados. Passo obrigatório para o cadastro de templates.'
      },
      {
        'name': 'Cadastro de templates de E-mail',
        'icon': 'code',
        'iconFill': true,
        'routerName': 'TemplateEmail',
        'routerPath': '/plataforma/:idConfigClienteApp/TemplateEmail',
        'embedPath': 'template-email',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 701,
        'showNavCardDash': true,
        'description': 'Cadastre modelos de e-mail para enviar a seus usuários. Permite o uso de macros.'
      },
      {
        'name': 'Gestão de E-mails bloqueados',
        'icon': 'code',
        'iconFill': true,
        'routerName': 'BlackList',
        'routerPath': '/plataforma/:idConfigClienteApp/BlackList',
        'embedPath': 'blacklist',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 'BlackList',
        'showNavCardDash': true,
        'description': 'Gerencie os e-mails bloqueados e as políticas que fazem com que eles sejam bloqueados.'
      },
      {
        'name': 'Cadastro de templates de Push',
        'icon': 'code',
        'iconFill': true,
        'routerName': 'TemplatePush',
        'routerPath': '/plataforma/:idConfigClienteApp/TemplatePush',
        'embedPath': 'template-push',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 702,
        'showNavCardDash': true,
        'description': 'Cadastre modelos de mensagens push para enviar a seus usuários com o app instalado. Permite o uso de macros.'
      },
      {
        'name': 'Configuração Chat 2.0 e WhatsApp',
        'icon': 'phone',
        'iconFill': true,
        'routerName': 'ConfiguracaoWhatsapp',
        'routerPath': '/plataforma/:idConfigClienteApp/ConfiguracaoWhatsapp',
        'embedPath': 'configuracao-whatsapp',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 703,
        'showNavCardDash': true,
        'description': 'Habilite o Chat 2.0 e registre sua conta de Whatsapp Businnes junto à Meta. Acesse as documentações oficiais para mais detalhes.'
      },
      {
        'name': 'Cadastro de templates de Whatsapp',
        'icon': 'phone',
        'iconFill': true,
        'routerName': 'TemplateWhatsapp',
        'routerPath': '/plataforma/:idConfigClienteApp/TemplateWhatsapp',
        'embedPath': 'template-whatsapp',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 704,
        'showNavCardDash': true,
        'description': 'Cadastre modelos de mensagens de Whatsapp. Os modelos devem ser aprovados pela Meta. Permite o uso de macros.'
      }
    ]
  },
  {
    'name': 'Segurança',
    'title': 'Segurança',
    'routerName': 'Seguranca',
    'routerPath': '/plataforma/:idConfigClienteApp',
    'idMenu': 4,
    'icon': 'security',
    'iconFill': true,
    'externalLink': false,
    'showChilds': true,
    'showNavCardDash': true,
    'childs': [
      {
        'name': 'Grupos de Autorização de Integração',
        'icon': 'collections',
        'iconFill': true,
        'routerName': 'ConfiguraAutorizacao',
        'routerPath': '/plataforma/:idConfigClienteApp/ConfiguraAutorizacao',
        'embedUrl': process.env.VUE_APP_URL_CONFIGURADOR_AUTORIZACAO_FRONT,
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 400,
        'showNavCardDash': true,
        'description': 'Configure e valide webservices de integração, de acordo com a Guideline de Provedor de Autenticação.'
      },
      {
        'name': 'Cadastro de Origens',
        'icon': 'collections',
        'iconFill': true,
        'routerName': 'ConfiguradorAplicacaoSeguranca',
        'routerPath': '/plataforma/:idConfigClienteApp/ConfiguradorAplicacaoSeguranca',
        'embedPath': 'configurador-aplicacao/:idConfigClienteApp/seguranca/origem',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 401,
        'showNavCardDash': true,
        'description': 'Cadastre os domínios ou IPs para executar as funcionalidades da aplicação via SDK, Mobile Saúde ou APIs públicas.'
      },
      {
        'name': 'Central de Logs',
        'icon': 'collections',
        'iconFill': true,
        'routerName': 'CentralLog',
        'routerPath': '/plataforma/:idConfigClienteApp/CentralLog',
        'embedPath': 'central-log',
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 403,
        'showNavCardDash': true,
        'description': 'Lista todos os registros de acessos à funcionalidades e outras integrações do Mosia Omnichannel'
      },
      {
        'name': 'Termos de uso',
        'icon': 'collections',
        'iconFill': true,
        'routerName': 'ListaTermosUso',
        'routerPath': '/plataforma/:idConfigClienteApp/ListaTermosUso',
        'tipoAplicacao': [1],
        'externalLink': true,
        'externalLinkNewTab': true,
        'idMenu': 404,
        'showNavCardDash': true,
        'description': 'Cadastre os termos de uso do seu site e aplicativo, tanto de primeiro acesso ou outras áreas específicas. Fique atento à LGPD'
      }
    ]
  },
  {
    'name': 'Usuários',
    'title': 'Usuários',
    'routerName': 'Usuarios',
    'routerPath': '/plataforma/:idConfigClienteApp',
    'idMenu': 1,
    'icon': 'people',
    'iconFill': true,
    'externalLink': false,
    'showChilds': true,
    'showNavCardDash': true,
    'childs': [
      {
        'name': 'Perfis de Atendente',
        'icon': 'collections',
        'iconFill': true,
        'routerName': 'PerfilAtendimentoLista',
        'routerPath': '/plataforma/:idConfigClienteApp/PerfilAtendimentoLista',
        'embedPath': 'perfilAtendimento/list',
        'embedUrl': process.env.VUE_APP_URL_OMNI_USER_FRONT,
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 100,
        'showNavCardDash': true,
        'description': 'Cadastro de perfis que agrupam uma série de regras e configurações propagadas a todos os atendentes.'
      },
      {
        'name': 'Usuários Atendente',
        'icon': 'collections',
        'iconFill': true,
        'routerName': 'AtendenteLista',
        'routerPath': '/plataforma/:idConfigClienteApp/AtendenteLista',
        'embedPath': 'atendente',
        'embedUrl': process.env.VUE_APP_URL_OMNI_USER_FRONT,
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 101,
        'showNavCardDash': true,
        'description': 'Cadastre atendentes para sua equipe. Defina seus dados pessoais, perfil de atendente e demais permissões.'
      },
      {
        'name': 'Perfis de Usuário do Painel',
        'icon': 'collections',
        'iconFill': true,
        'routerName': 'PerfilLista',
        'routerPath': '/plataforma/:idConfigClienteApp/PerfilLista',
        'embedPath': '/perfil/lista',
        'embedUrl': process.env.VUE_APP_URL_OMNI_USER_FRONT,
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 102,
        'showNavCardDash': true,
        'description': 'Cadastro de perfis que agrupam uma série de regras e configurações propagadas a todos os usuários deste painel'
      },
      {
        'name': 'Usuários do Painel',
        'icon': 'collections',
        'iconFill': true,
        'routerName': 'UsuarioLista',
        'routerPath': '/plataforma/:idConfigClienteApp/UsuarioLista',
        'embedPath': '/usuario/lista',
        'embedUrl': process.env.VUE_APP_URL_OMNI_USER_FRONT,
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 103,
        'showNavCardDash': true,
        'description': 'Cadastre sua equipe de usuários deste painel. Defina seus dados pessoais, perfil, operadora e demais permissões.'
      }
    ]
  },
  {
    'name': 'Atendimento',
    'title': 'Atendimento',
    'routerName': 'chatbotAtedimento',
    'routerPath': '/plataforma/:idConfigClienteApp',
    'idMenu': 10,
    'icon': 'support',
    'iconFill': true,
    'externalLink': false,
    'showChilds': true,
    'showNavCardDash': true,
    'childs': [
      {
        'name': 'Fluxos de conversa',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'chatbotFlows',
        'routerPath': '/plataforma/:idConfigClienteApp/chatbotFlows',
        'embedPath': 'flows',
        'embedUrl': process.env.VUE_APP_URL_CHAT_BOT,
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 1002,
        'showNavCardDash': true,
        'description': 'Crie fluxos de conversa para atendimento automático ou humano. Defina as regras de negócio e as respostas do chatbot.'
      },
      {
        'name': 'Filas de atendimento',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'chatbotQueues',
        'routerPath': '/plataforma/:idConfigClienteApp/chatbotQueues',
        'embedPath': 'queues',
        'embedUrl': process.env.VUE_APP_URL_CHAT_BOT,
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 1003,
        'showNavCardDash': true,
        'description': 'Gerencie as filas para atendimento humano dentro do seu chatbot.'
      },
      {
        'name': 'Tarefas do chat',
        'icon': 'todo',
        'iconFill': true,
        'routerName': 'chatbotTasks',
        'routerPath': '/plataforma/:idConfigClienteApp/chatbotTasks',
        'embedPath': 'tasks',
        'embedUrl': process.env.VUE_APP_URL_CHAT_BOT,
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 1004,
        'showNavCardDash': true,
        'description': 'Crie tarefas para serem executadas pelos usuários dentro do chatbot.'
      },
      {
        'name': 'Expedientes',
        'icon': 'settings',
        'iconFill': true,
        'routerName': 'chatbotExpedients',
        'routerPath': '/plataforma/:idConfigClienteApp/chatbotExpedients',
        'embedPath': 'expedients',
        'embedUrl': process.env.VUE_APP_URL_CHAT_BOT,
        'tipoAplicacao': [1],
        'externalLink': false,
        'idMenu': 1005,
        'showNavCardDash': true,
        'description': 'Adicione os horários de atendimento das suas filas de atendimento humano.'
      }
      // {
      //   'name': 'Atendimento URA',
      //   'icon': 'settings',
      //   'iconFill': true,
      //   'routerName': 'atendimentoUra',
      //   'embedPath': '/atendimentoUra/:idConfigClienteApp',
      //   'tipoAplicacao': [1],
      //   'externalLink': false,
      //   'idMenu': 1006,
      //   'showNavCardDash': true,
      //   'description': 'Gerencie as integrações com fornecedores para configurar atendimento URA.'
      // }
    ]
  },
  {
    'name': 'Ajuda',
    'title': 'Ajuda',
    'routerName': 'Ajuda',
    'routerPath': '/plataforma/:idConfigClienteApp',
    'idMenu': 8,
    'icon': 'help',
    'iconFill': true,
    'externalLink': false,
    'showChilds': false,
    'showNavCardDash': true,
    'childs': [
      {
        'name': 'Abrir Chamado',
        'icon': 'open_in_new',
        'iconFill': true,
        'routerName': 'AbrirChamado',
        'routerPath': '/plataforma/:idConfigClienteApp/AbrirChamado',
        'tipoAplicacao': [1],
        'externalLink': true,
        'externalLinkNewTab': true,
        'idMenu': 800,
        'showNavCardDash': true,
        'description': 'Abra um chamado e reporte um problema para a equipe de suporte. Acompanhe o status do chamado e receba atualizações por e-mail.'
      },
      {
        'name': 'Documentação',
        'icon': 'open_in_new',
        'iconFill': true,
        'routerName': 'Documentacao',
        'routerPath': '/plataforma/:idConfigClienteApp/Documentacao',
        'tipoAplicacao': [1],
        'externalLink': true,
        'externalLinkNewTab': true,
        'idMenu': 801,
        'showNavCardDash': true,
        'description': 'Acesse nossa documentação completa para obter informações sobre o uso da plataforma, recursos disponíveis, tutoriais e guias de integração.'
      },
      {
        'name': 'Download do App de Sandbox',
        'icon': 'open_in_new',
        'iconFill': true,
        'routerName': 'DownloadAppSandbox',
        'routerPath': '/plataforma/:idConfigClienteApp/DownloadAppSandbox',
        'tipoAplicacao': [1],
        'externalLink': true,
        'externalLinkNewTab': true,
        'idMenu': 802,
        'showNavCardDash': true,
        'description': 'Instale gratuitamente nosso aplicativo de demonstrações e configure sua central de atendimento. Entre com suas credenciais Mosia Omnichannel.'
      },
      {
        'name': 'Painel do Atendente 2.0',
        'icon': 'open_in_new',
        'iconFill': true,
        'routerName': 'NovoPainelAtendente',
        'routerPath': '/plataforma/:idConfigClienteApp/NovoPainelAtendente',
        'tipoAplicacao': [1],
        'externalLink': true,
        'externalLinkNewTab': true,
        'idMenu': 803,
        'showNavCardDash': true,
        'description': 'Painel utilizado no dia-a-dia dos atendentes para atender chamados, conversar e fornecer suporte personalizado aos clientes finais.'
      },
      {
        'name': 'Painel do Atendente 2.0 - Sandbox',
        'icon': 'open_in_new',
        'iconFill': true,
        'routerName': 'NovoPainelAtendenteSandbox',
        'routerPath': '/plataforma/:idConfigClienteApp/NovoPainelAtendenteSandbox',
        'tipoAplicacao': [1],
        'externalLink': true,
        'externalLinkNewTab': true,
        'idMenu': 803,
        'showNavCardDash': true,
        'description': 'Painel utilizado no dia-a-dia dos atendentes para atender chamados, conversar e fornecer suporte personalizado aos clientes finais.'
      },
      {
        'name': 'Site Institucional',
        'icon': 'open_in_new',
        'iconFill': true,
        'routerName': 'SiteInstitucional',
        'routerPath': '/plataforma/:idConfigClienteApp/SiteInstitucional',
        'tipoAplicacao': [1],
        'externalLink': true,
        'externalLinkNewTab': true,
        'idMenu': 804,
        'showNavCardDash': true,
        'description': 'Acesse o site institucional de sua empresa'
      },
      {
        'name': 'Informativos',
        'icon': 'open_in_new',
        'iconFill': true,
        'routerName': 'SiteInformativos',
        'routerPath': '/plataforma/:idConfigClienteApp/SiteInformativos',
        'tipoAplicacao': [1],
        'externalLink': true,
        'externalLinkNewTab': true,
        'idMenu': 806,
        'showNavCardDash': true,
        'description': 'Conteúdos, alertas e atividades realizadas pelos times técnicos da Mobile Saúde, relacionados a melhorias, correções ou serviços.'
      }
    ]
  }
]
